import { render, staticRenderFns } from "./comprehensiveWarningList.vue?vue&type=template&id=7df44fb2&scoped=true"
import script from "./comprehensiveWarningList.vue?vue&type=script&lang=js"
export * from "./comprehensiveWarningList.vue?vue&type=script&lang=js"
import style0 from "./comprehensiveWarningList.vue?vue&type=style&index=0&id=7df44fb2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df44fb2",
  null
  
)

export default component.exports